import React from 'react';
import { IconCircleExclamation } from 'adc-ui-components';

import Modal from './Modal';

const UnhandledError = ({ closeModal }) => (
  <Modal isOpen onRequestClose={closeModal}>
    <div className="text-center">
      <IconCircleExclamation className="mb12 svg-icon--42" />
      <div className="hgroup mb24">
        <h2>Looks like something went wrong</h2>
        <p className="body2">Please reload the page and try again.</p>
      </div>
      <button className="button button--primary" type="button" onClick={() => window.location.reload()}>Reload Now</button>
    </div>
  </Modal>
);

export default UnhandledError;
